import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs-compat/Observable';
import { GenericService } from 'src/app/commons/generic.service';
import { SistemaTipoSolicitacao } from 'src/app/model/sistemaTipoSolicitacao';
import { TipoSolicitacao } from 'src/app/model/tipoSolicitacao';

@Injectable({
  providedIn: 'root'
})
export class TipoSolicitacaoService  extends GenericService {

  private relativePath = 'api/tipoSolicitacao';
  resultadoChamado: Observable<string>;

  constructor(http: HttpClient) {
      super(http);
  }

  obterListaTipoSolicitacao(idSistemas: Array<number>): Observable<Array<TipoSolicitacao>> {
    return this.http.get<Array<TipoSolicitacao>>(this.url + this.relativePath + `/find-tipo-solicitacao-by-idSistema/${idSistemas}`);
  }

  obterListaSisemaTipoSolicitacao(idSistemas: Array<number>, responsavel:string): Observable<Array<SistemaTipoSolicitacao>> {
    return this.http.get<Array<SistemaTipoSolicitacao>>(this.url + this.relativePath + `/find-sistema-tipo-solicitacao-by-idSistema/${idSistemas}//responsavel/${responsavel}`);
  }
}
